module.exports = __webpack_public_path__ + "static/img/indexImg0.32378df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexImg0.jpg
// module id = ERCO
// module chunks = 3